/**
 * Format currency to a decimal format
 *
 * @param {number} cents Currency amount to convert.
 * @returns {number} Converted currency.
 */
export default function( cents ) {
	return cents / 100;
}
